import {QueueDataModel, QueueAgentModel, QueueStatus, QueueStatusColor} from './queue-data.model';

export class ServiceNumberUtil {
  static filterCallbackQueues(queues: QueueDataModel[]): QueueDataModel[] {
    const ret = queues.filter(q => q.type === 3 && q.kickoutNoAgents !== 9999);
    return ret;
  }

  static getQueuesWhichAgentIsMemberOf(queues: QueueDataModel[], agentLogin: string): QueueDataModel[] {
    const ret = this.filterCallbackQueues(queues).filter(q => q.queueAgents.find(qa => qa.login === agentLogin));
    return ret;
  }

  static getQueueAgentStatusColor(queueAgent: QueueAgentModel): string {
    if (queueAgent && queueAgent.state > 0) {
      return queueAgent.active ? QueueStatusColor.STATUS_GREEN : QueueStatusColor.STATUS_RED;
    }
    return QueueStatusColor.STATUS_GRAY as string;
  }

  static getQueueStatus(queueAgent: QueueAgentModel): string {
    if (queueAgent && queueAgent.state > 0) {
      return queueAgent.active ? QueueStatus.STATUS_LOGGEDIN : QueueStatus.STATUS_INACTIVE;
    }
    return QueueStatus.STATUS_LOGGEDOUT as string;
  }
}
